
/**
 * Impulse Theme - component-facets.js
 * Enables filtering, price range slider, and dynamic URL updates.
 */
document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('.filter-form');
  if (!form) return;

  form.addEventListener('change', function () {
    form.submit();
  });

  const priceSlider = document.querySelector('.price-range__slider');
  if (priceSlider && window.noUiSlider) {
    const minInput = form.querySelector('.price-range__input-min');
    const maxInput = form.querySelector('.price-range__input-max');
    const min = parseFloat(priceSlider.dataset.min);
    const max = parseFloat(priceSlider.dataset.max);
    const startMin = parseFloat(priceSlider.dataset.minValue);
    const startMax = parseFloat(priceSlider.dataset.maxValue);

    noUiSlider.create(priceSlider, {
      start: [startMin, startMax],
      connect: true,
      range: {
        min: min,
        max: max
      },
      step: 1
    });

    priceSlider.noUiSlider.on('update', function (values) {
      minInput.value = Math.round(values[0]);
      maxInput.value = Math.round(values[1]);
    });

    priceSlider.noUiSlider.on('change', function () {
      form.submit();
    });
  }
});
